import type {
  GenericItemDataSheet,
  GenericItemDataSheetAttributes,
  GenericItemDataSheetGroups,
} from '@marty-js/api-sdk/types';

export const extractTopSpecs = (groups: any[], criteria: { label: string; key: string }[]) => {
  const topSpecs: Record<string, string> = {};

  groups?.forEach((group) => {
    group.attributes
      ?.filter((attribute: any) => attribute?.topSpec && attribute?.value)
      .forEach((attribute: any) => {
        topSpecs[attribute?.shortSlug] = attribute?.value;

        if (!criteria.find((c) => c.key === attribute?.shortSlug)) {
          criteria.push({
            label: attribute?.name,
            key: attribute?.shortSlug,
          });
        }
      });
  });

  return topSpecs;
};

export const getTopSpecsFromDataSheet = (datasheet: GenericItemDataSheet): GenericItemDataSheet => {
  const attributes: GenericItemDataSheetAttributes[] = [];
  datasheet?.groups?.forEach((dataSheetGroup: GenericItemDataSheetGroups) => {
    dataSheetGroup.attributes?.forEach((attribute: GenericItemDataSheetAttributes) => {
      if (attribute.topSpec) {
        if (attribute.boolValue === true || attribute.type !== 'bool') {
          attributes.push(attribute);
        }
      }
    });
  });

  const topSpecGroup: GenericItemDataSheetGroups = {
    shortSlug: 'topSpec',
    name: 'top',
    attributes,
    __typename: 'DataSheetGroup',
  };

  return { itemTitle: null, groups: [topSpecGroup], __typename: 'DataSheet' };
};

type FormatTopSpec = {
  short: string;
  type: string;
  name: string;
  value: string;
};
export const formatTopSpecsFromDataSheet = (datasheet: GenericItemDataSheet): FormatTopSpec[] => {
  const topSpec: FormatTopSpec[] = [];
  datasheet?.groups?.forEach((group: GenericItemDataSheetGroups) =>
    group.attributes?.forEach((spec: GenericItemDataSheetAttributes) => {
      const { value, name, type, boolValue } = spec;
      if (spec.topSpec && (boolValue === true || type !== 'bool')) {
        const short = type === 'bool' ? name : value;
        if (short) {
          topSpec.push({
            short,
            value,
            name,
            type,
          });
        }
      }
    }),
  );

  return topSpec;
};
